var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.074 7.74009C15.074 9.99014 13.25 11.8142 11 11.8142C8.74991 11.8142 6.92589 9.99014 6.92589 7.74009C6.92589 5.49004 8.74991 3.66602 11 3.66602C13.25 3.66602 15.074 5.49004 15.074 7.74009Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82211 12.9331C8.4675 12.7564 8.0852 12.629 7.68899 12.629C5.4675 12.629 3.66663 14.4299 3.66663 16.6513V16.9068C3.66663 17.6943 4.30503 18.3327 5.09255 18.3327H16.9074C17.6949 18.3327 18.3333 17.6943 18.3333 16.9068V16.6513C18.3333 14.4299 16.5324 12.629 14.3109 12.629C13.9147 12.629 13.5324 12.7564 13.1778 12.9331C12.522 13.26 11.7825 13.4438 11 13.4438C10.2175 13.4438 9.4779 13.26 8.82211 12.9331Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile.953ea846d9c6159804ba3270cf27b2ac.svg";